interface FingerprintSource {
  file?: File | null;
  modelName?: string | null;
}

const normalize = (value?: string | null) => (value || '').trim().toLowerCase();

/**
 * Genera un fingerprint determinista para un modelo IFC a partir de los metadatos
 * disponibles (nombre del archivo, tamaño, timestamp y nombre interno del IFC).
 * Sirve para identificar de forma estable un mismo archivo entre sesiones.
 */
export function createIFCFingerprint({ file, modelName }: FingerprintSource): string | null {
  if (!file && !modelName) {
    return null;
  }

  const parts = [
    modelName ? `ifc:${normalize(modelName)}` : null,
    file?.name ? `file:${normalize(file.name)}` : null,
    typeof file?.size === 'number' ? `size:${file.size}` : null,
    typeof file?.lastModified === 'number' ? `ts:${file.lastModified}` : null,
  ].filter(Boolean) as string[];

  if (parts.length === 0) {
    return null;
  }

  return parts.join('|');
}

